import { render } from "./StoreMonthTable.vue?vue&type=template&id=0f239aa2"
import script from "./StoreMonthTable.vue?vue&type=script&lang=js"
export * from "./StoreMonthTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pushpan/Projects/WebApps/Python/Django/store_manage/punil/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__